import { render, staticRenderFns } from "./PatientBillingBPJS.vue?vue&type=template&id=e768acb6&scoped=true"
import script from "./PatientBillingBPJS.vue?vue&type=script&lang=js"
export * from "./PatientBillingBPJS.vue?vue&type=script&lang=js"
import style0 from "./PatientBillingBPJS.vue?vue&type=style&index=0&id=e768acb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e768acb6",
  null
  
)

export default component.exports